'use client';
import { createContext } from 'react';

export interface SegmentPageViewContextValue {
  pageName: string;
  pageViewId: string;
  pageViewReady: boolean;
  previousPageViewId: string;
}

export const SegmentPageViewContext =
  createContext<SegmentPageViewContextValue | null>(null);
